export default {
  items: [],
  pagination: { page: 1, pages: 1, size: 50, count: 0, indexStartsFrom: 1 },
  filters: {},
};
